import { useFeatureFlags } from "@smart/bridge-feature-flags-dom";
import { Link } from "@smart/itops-sb-design-system-dom";
import { useLoadSetting } from "@smart/manage-gql-client-dom";

import { useIntakeSettingsNavigation } from "../settings/navigate";
import { DismissibleBanner } from "../shared";
import { GqlSubmissionSummary } from "../types";

const dismissedBannerKey = "dismissed-banner.automatic-reminders-off";

const waitingOnClientsCount = (submissions: GqlSubmissionSummary[]) =>
  submissions.filter(
    (submission) =>
      submission.values.status === "active" &&
      !submission.values.deleted &&
      (submission.values.communicationMethod === "communicate" ||
        submission.values.communicationMethod === "email"),
  ).length;

export const AutomaticRemindersOffBanner = ({
  submissions,
  loading,
}: {
  submissions: GqlSubmissionSummary[];
  loading: boolean;
}) => {
  const { "LINK-3736": automaticRemindersFlag } = useFeatureFlags();
  const { result: setting, loading: settingLoading } = useLoadSetting(
    {},
    { skip: !automaticRemindersFlag },
  );
  const { navigate } = useIntakeSettingsNavigation();

  if (
    !automaticRemindersFlag ||
    loading ||
    settingLoading ||
    setting?.reminder?.enabled
  )
    return null;

  const waitingCount = waitingOnClientsCount(submissions);
  if (waitingCount === 0) return null;

  const waitingText = `${waitingCount === 1 ? "1 form is" : `${waitingCount} forms are`} waiting to be completed. Set up scheduled reminders to send clients regular reminders to complete their form.`;

  return (
    <DismissibleBanner
      storageKey={dismissedBannerKey}
      variant="info"
      content={
        <div className="flex items-center justify-between gap-[1.6rem]">
          <span>{waitingText}</span>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            text="Set up reminders"
            onClick={() => navigate("client-messages")}
            dataTestId="set-up-reminders"
          />
        </div>
      }
    />
  );
};
